import { RtCommonApiRoutes } from 'RtExports/routes';
import {
	RateSheetGenerationIndexRequest,
	RateSheetGenerationIndexResponse,
	RateSheetGeneratorIndexRequest,
	RateSheetGeneratorIndexResponse,
	RateSheetGeneratorProfileResponse
} from 'RtModels';
import { RateSheetGeneratorResource } from 'RtUi/app/AccountManagement/RateSheetGenerator/libs/resources/RateGeneratorResource';
import {
	FullResponse,
	handleGetRequest
} from 'RtUi/utils/http/AxiosHttpRequest';
import { useQuery } from 'react-query';

const fetchRateSheetGenerator = async (
	sipAgentId: number
): Promise<RateSheetGeneratorProfileResponse> => {
	const data = await new RateSheetGeneratorResource().getProfile(sipAgentId);
	return data;
};

const fetchRateSheetGenerators = async (
	queryParams?: RateSheetGeneratorIndexRequest
): Promise<FullResponse<RateSheetGeneratorIndexResponse[]>> => {
	return handleGetRequest<RateSheetGeneratorIndexResponse[], true>(
		RtCommonApiRoutes.RateSheetGenerator.Index,
		{
			includeFullResponse: true,
			queryParams
		}
	);
};

const fetchRateSheetGeneration = async (): Promise<
	FullResponse<RateSheetGenerationIndexResponse[]>
> => {
	return handleGetRequest<RateSheetGenerationIndexResponse[], true>(
		RtCommonApiRoutes.RateSheetGeneration.Index,
		{
			includeFullResponse: true
		}
	);
};

export const useGetRateSheetGenerators = (
	queryParams?: RateSheetGeneratorIndexRequest
) => {
	return useQuery<FullResponse<RateSheetGeneratorIndexResponse[]>, Error>(
		[`useGetRateGenerations`, queryParams],
		() => fetchRateSheetGenerators(queryParams),
		{ enabled: true }
	);
};

export const useGetRateSheetGenerator = (rateSheetGeneratorId: number) => {
	return useQuery<RateSheetGeneratorProfileResponse, Error>(
		[`getRateSheetGenerator${rateSheetGeneratorId}`, rateSheetGeneratorId],
		() => fetchRateSheetGenerator(rateSheetGeneratorId),
		{ enabled: true }
	);
};

export const useGetRateSheetGeneration = () => {
	return useQuery<FullResponse<RateSheetGenerationIndexResponse[]>, Error>(
		[],
		() => fetchRateSheetGeneration(),
		{ enabled: true }
	);
};
